<vwui-header>
  <h2 a11yPageTitleLevel="1">{{ "PAGE_OPPORTUNITY_LIBRARY.title" | translate}}</h2>
</vwui-header>

@if (loadingSpinnerService.isSpinnerVisible()) {
  <vwui-spinner></vwui-spinner>
}

@if (!loadingSpinnerService.isSpinnerVisible()) {
  <div class="mt-lg">
    <app-library-mgmt [library]="opportunitiesLibrary" [companyTypeId]="companyTypeId">
    </app-library-mgmt>
  </div>
}
